import { render, staticRenderFns } from "./AlbumBody.vue?vue&type=template&id=52085ea8&scoped=true&"
import script from "./AlbumBody.vue?vue&type=script&lang=js&"
export * from "./AlbumBody.vue?vue&type=script&lang=js&"
import style0 from "./AlbumBody.vue?vue&type=style&index=0&id=52085ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52085ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52085ea8')) {
      api.createRecord('52085ea8', component.options)
    } else {
      api.reload('52085ea8', component.options)
    }
    module.hot.accept("./AlbumBody.vue?vue&type=template&id=52085ea8&scoped=true&", function () {
      api.rerender('52085ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/Album/AlbumBody.vue"
export default component.exports